(function () {
  function closestCard(el) {
    return el.closest('.b2b-qo__card');
  }

  function formatMoneyFromTheme(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    return (cents / 100).toFixed(2);
  }

  function show(el) { if (el) el.style.display = ''; }
  function hide(el) { if (el) el.style.display = 'none'; }

  function normalize(s) {
    return (s || '').toString().trim().toLowerCase();
  }

  async function getCartItemCount() {
    try {
      const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      if (!res.ok) return null;
      const cart = await res.json();
      return typeof cart.item_count === 'number' ? cart.item_count : null;
    } catch (e) {
      return null;
    }
  }

  function openCartDrawer() {
    // Your theme uses a custom element <cart-drawer id="cart-drawer">
    const drawer = document.querySelector('cart-drawer#cart-drawer');
    if (!drawer) return;

    // Prefer component API if present
    try {
      if (typeof drawer.open === 'function') { drawer.open(); return; }
      if (typeof drawer.show === 'function') { drawer.show(); return; }
      if (typeof drawer.setOpen === 'function') { drawer.setOpen(true); return; }
      if (typeof drawer.toggle === 'function') { drawer.toggle(true); return; }
    } catch (e) {}

    // Fallback attribute/class patterns used by many drawer implementations
    try { drawer.setAttribute('open', ''); } catch (e) {}
    try { drawer.setAttribute('aria-hidden', 'false'); } catch (e) {}
    try { drawer.classList.add('is-open', 'drawer--open'); } catch (e) {}

    // Fire common theme events (harmless if unused)
    try { document.dispatchEvent(new CustomEvent('cart:open')); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('drawer:open', { detail: { id: 'cart-drawer' } })); } catch (e) {}

    // Last resort: click a trigger if your header has one
    const trigger =
      document.querySelector('[aria-controls="cart-drawer"]') ||
      document.querySelector('[data-drawer-trigger="cart"]') ||
      document.querySelector('[data-cart-drawer-trigger]') ||
      document.querySelector('a[href="/cart"]');

    if (trigger && typeof trigger.click === 'function') trigger.click();
  }

  async function addToCart(variantId, quantity) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
    });

    if (!res.ok) {
      let msg = 'Could not add to cart.';
      try {
        const data = await res.json();
        if (data && (data.description || data.message)) msg = data.description || data.message;
      } catch (e) {}
      throw new Error(msg);
    }

    return res.json();
  }

  async function refreshCartUI() {
    try {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:updated'));
    } catch (e) {}

    const sectionIds = [
      'sections--18751811322038__header',
      'sections--18751811354806__cart-drawer'
    ];

    const url = `${window.location.pathname}?sections=${sectionIds.join(',')}`;

    try {
      const res = await fetch(url, { headers: { 'Accept': 'application/json' } });
      if (!res.ok) return;

      const sections = await res.json();

      const cartDrawerHtml = sections['sections--18751811354806__cart-drawer'];
      if (cartDrawerHtml) {
        const doc = new DOMParser().parseFromString(cartDrawerHtml, 'text/html');
        const newEl = doc.querySelector('#shopify-section-sections--18751811354806__cart-drawer');
        const oldEl = document.querySelector('#shopify-section-sections--18751811354806__cart-drawer');
        if (newEl && oldEl) oldEl.replaceWith(newEl);
      }

      const headerHtml = sections['sections--18751811322038__header'];
      if (headerHtml) {
        const doc = new DOMParser().parseFromString(headerHtml, 'text/html');
        const newEl = doc.querySelector('#shopify-section-sections--18751811322038__header');
        const oldEl = document.querySelector('#shopify-section-sections--18751811322038__header');
        if (newEl && oldEl) oldEl.replaceWith(newEl);
      }
    } catch (e) {}
  }

  function updateCardFromSelectedOption(selectEl) {
    const card = closestCard(selectEl);
    if (!card) return;

    const opt = selectEl.options[selectEl.selectedIndex];
    if (!opt) return;

    const variantId = parseInt(opt.value, 10);
    const available = opt.getAttribute('data-available') === 'true';
    const priceCents = parseInt(opt.getAttribute('data-price') || '0', 10);
    const compareCents = parseInt(opt.getAttribute('data-compare') || '0', 10);
    const sku = opt.getAttribute('data-sku') || '';
    const moq = parseInt(opt.getAttribute('data-moq') || '1', 10);
    const imgUrl = opt.getAttribute('data-img') || '';

    card.setAttribute('data-variant-id', String(variantId));
    card.setAttribute('data-base-price', String(priceCents)); // for sorting

    // Update media link to keep variant
    const mediaLink = card.querySelector('.b2b-qo__media');
    if (mediaLink) {
      const baseUrl = (mediaLink.getAttribute('href') || '').split('?')[0];
      if (baseUrl) mediaLink.setAttribute('href', `${baseUrl}?variant=${variantId}`);
    }

    // Price
    const priceEl = card.querySelector('[data-price]');
    const compareEl = card.querySelector('[data-compare]');
    if (priceEl) priceEl.textContent = formatMoneyFromTheme(priceCents);

    if (compareEl) {
      if (compareCents > priceCents) {
        compareEl.textContent = formatMoneyFromTheme(compareCents);
        show(compareEl);
      } else {
        hide(compareEl);
      }
    }

    // SKU
    const skuEl = card.querySelector('[data-sku]');
    if (skuEl) skuEl.textContent = sku ? `SKU: ${sku}` : '';



    // MOQ + enable/disable
    const qtyEl = card.querySelector('.b2b-qo__qty');
    const addBtn = card.querySelector('.b2b-qo__add');
    const minusBtn = card.querySelector('[data-qty-minus]');
    const plusBtn = card.querySelector('[data-qty-plus]');

    if (qtyEl) {
      qtyEl.min = String(moq);
      const current = parseInt(qtyEl.value || String(moq), 10);
      qtyEl.value = String(Math.max(moq, isNaN(current) ? moq : current));
      qtyEl.disabled = !available;
    }

    if (addBtn) addBtn.disabled = !available;
    if (minusBtn) minusBtn.disabled = !available;
    if (plusBtn) plusBtn.disabled = !available;

    // Variant image swap
    const imgEl = card.querySelector('[data-variant-image]');
    if (imgEl && imgUrl) imgEl.src = imgUrl;
  }

  function stepQty(card, delta) {
    const qtyEl = card.querySelector('.b2b-qo__qty');
    if (!qtyEl || qtyEl.disabled) return;

    const min = parseInt(qtyEl.min || '1', 10);
    const step = parseInt(qtyEl.step || '1', 10);
    const current = parseInt(qtyEl.value || String(min), 10);
    const next = (isNaN(current) ? min : current) + (delta * step);
    qtyEl.value = String(Math.max(min, next));
  }

  // Open/close accordions based on visible cards (after filter applied)
  function updateAccordionsForVisibleResults(sectionEl, query) {
    const q = normalize(query);
    const detailsEls = sectionEl.querySelectorAll('details.b2b-qo__collection');

    detailsEls.forEach((details) => {
      const cardsWrap = details.querySelector('[data-qo-cards]');
      if (!cardsWrap) return;

      const cards = Array.from(cardsWrap.querySelectorAll('.b2b-qo__card'));
      const hasVisible = cards.some((c) => c.style.display !== 'none');

      if (q) {
        details.open = hasVisible;
      }
    });
  }

  // FILTER + SORT
  function applyFilterAndSort(sectionEl) {
    const filterEl = sectionEl.querySelector('[data-qo-filter]');
    const sortEl = sectionEl.querySelector('[data-qo-sort]');
    const query = normalize(filterEl ? filterEl.value : '');
    const sort = sortEl ? sortEl.value : 'featured';

    sectionEl.querySelectorAll('[data-qo-cards]').forEach((cardsWrap) => {
      const cards = Array.from(cardsWrap.querySelectorAll('.b2b-qo__card'));

      // Filter (title + variant text + sku)
      cards.forEach((card) => {
        const title = normalize(card.getAttribute('data-product-title'));
        const variant = normalize(card.querySelector('.b2b-qo__variant')?.textContent);
        const sku = normalize(card.querySelector('[data-sku]')?.textContent);

        const match = (!query) || title.includes(query) || variant.includes(query) || sku.includes(query);
        card.style.display = match ? '' : 'none';
      });

      // Sort (only within this collection accordion)
      const visibleCards = cards.filter(c => c.style.display !== 'none');

      const cmpTitleAsc = (a,b) => (a.getAttribute('data-product-title')||'').localeCompare(b.getAttribute('data-product-title')||'');
      const cmpTitleDesc = (a,b) => (b.getAttribute('data-product-title')||'').localeCompare(a.getAttribute('data-product-title')||'');
      const cmpPriceAsc = (a,b) => (parseInt(a.getAttribute('data-base-price')||'0',10) - parseInt(b.getAttribute('data-base-price')||'0',10));
      const cmpPriceDesc = (a,b) => (parseInt(b.getAttribute('data-base-price')||'0',10) - parseInt(a.getAttribute('data-base-price')||'0',10));

      let sorter = null;
      if (sort === 'title-asc') sorter = cmpTitleAsc;
      if (sort === 'title-desc') sorter = cmpTitleDesc;
      if (sort === 'price-asc') sorter = cmpPriceAsc;
      if (sort === 'price-desc') sorter = cmpPriceDesc;

      if (sorter) {
        visibleCards.sort(sorter).forEach(card => cardsWrap.appendChild(card));
      }
    });

    updateAccordionsForVisibleResults(sectionEl, query);
  }

  // Event handlers
  document.addEventListener('change', function (e) {
    const select = e.target.closest('.b2b-qo__select');
    if (select) updateCardFromSelectedOption(select);

    const sort = e.target.closest('[data-qo-sort]');
    if (sort) {
      const sectionEl = e.target.closest('.b2b-qo');
      if (sectionEl) applyFilterAndSort(sectionEl);
    }
  });

  document.addEventListener('input', function (e) {
    const filter = e.target.closest('[data-qo-filter]');
    if (!filter) return;
    const sectionEl = e.target.closest('.b2b-qo');
    if (sectionEl) applyFilterAndSort(sectionEl);
  });

  document.addEventListener('click', function (e) {
    const minus = e.target.closest('[data-qty-minus]');
    if (minus) {
      const card = closestCard(minus);
      if (card) stepQty(card, -1);
      return;
    }

    const plus = e.target.closest('[data-qty-plus]');
    if (plus) {
      const card = closestCard(plus);
      if (card) stepQty(card, +1);
      return;
    }
  });

document.addEventListener('click', async function (e) {
  const btn = e.target.closest('.b2b-qo__add');
  if (!btn) return;

  const card = closestCard(btn);
  if (!card) return;

  const msgEl = card.querySelector('.b2b-qo__msg');
  const qtyEl = card.querySelector('.b2b-qo__qty');

  const variantId = parseInt(card.getAttribute('data-variant-id'), 10);
  const min = qtyEl ? parseInt(qtyEl.min || '1', 10) : 1;
  const qty = qtyEl ? Math.max(min, parseInt(qtyEl.value || String(min), 10)) : 1;

  const wasCount = await getCartItemCount();
  let addedSuccessfully = false;

  btn.disabled = true;
  if (msgEl) msgEl.textContent = 'Adding…';

  try {
    await addToCart(variantId, qty);
    addedSuccessfully = true;
    if (msgEl) msgEl.textContent = 'Added ✓';
  } catch (err) {
    if (msgEl) msgEl.textContent = (err && err.message) ? err.message : 'Error adding.';
  } finally {
    await refreshCartUI();

    if (addedSuccessfully && wasCount === 0) {
      openCartDrawer();
    }

    const select = card.querySelector('.b2b-qo__select');
    if (select) {
      const opt = select.options[select.selectedIndex];
      const available = opt && opt.getAttribute('data-available') === 'true';
      btn.disabled = !available;
    } else {
  btn.disabled = card.getAttribute('data-available') !== 'true';
}

    setTimeout(() => { if (msgEl) msgEl.textContent = ''; }, 5000);
  }
});

  // Init
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.b2b-qo__select').forEach(updateCardFromSelectedOption);
    document.querySelectorAll('.b2b-qo').forEach(applyFilterAndSort);
  });

  // Optional: support Shopify theme editor section reload
  document.addEventListener('shopify:section:load', function (e) {
    const sectionRoot = e.target;
    if (!sectionRoot) return;

    sectionRoot.querySelectorAll('.b2b-qo__select').forEach(updateCardFromSelectedOption);
    sectionRoot.querySelectorAll('.b2b-qo').forEach(applyFilterAndSort);
  });
})();
